<template>
  <div id="listView2" v-infinite-scroll="onLoadMore" infinite-scroll-throttle-delay="500" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="listItem">
    <div id="listView"  v-if="data.length > 0">
      <div class="flex between list-item" v-for="(item, i) in data" :key="i" @click="onRoute(item.id)">
        <div class="headImg-part">
          <div class="headImg-border">
            <img :src="item.imageList[0]" class="headImg" v-if="item.imageList && item.imageList.length > 0">
            <img src="../assets/photo-normal.png" class="headImg" v-else>
          </div>
        </div>
        <div class="content-part">
          <div>
            <div class="fontName">{{ item.name }}</div>
          </div>
          <div class="fontAddress" style="margin:5px 0px">
            <div>{{ item.city }}<span v-if="item.district">·</span>{{ item.district }}</div>
          </div>
          <div class="fontIntro" v-html="item.address"></div>
          <div class="clr-simple fz-12 tag-list flex wrap"><span v-for="(label, n) in item.typeList" :key="n"><span
                class="tag tagItem">{{ label }}</span></span></div>
        </div>
      </div>
    </div>
    <div class="noDataView" v-else>
      <div>
        <img src="../assets/none.svg" class="list-none">
        <div class="list-text">未找到符合条件的咨询室</div>
        <div class="list-text">请试试更换上方筛选条件</div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    onLoadMore:{
      type: Function,
      default: function () {
        return []
      }
    },
    data: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      flagType: false
    }
  },
  methods: {
   
    onRoute(id) {
      sessionStorage.setItem("scrollPos",document.getElementById('listView2').scrollTop)
      this.$router.push({
        path: '/detail',
        query: {
          id: id
        }
      });
    }
  },

};

</script>
<style lang="stylus">
  @import '../stylus/components/listItem.styl'
  
  .listItem{
    background: #fff;
    width: 100%;
    overflow-x: hidden;
    height:calc(100% - 100px)
  }
.headImg-border{
  width: 124px;
  height: 93px;
}
.flex.between {
    justify-content: left;
    
}
.align {
    width: 100%;
    padding-top: 5px;
    justify-content: left;
}
.listItem .margin-10 {
    margin: 10px 0;
}
.fontAddress{
  text-align: left
  color: #3DCCBD;

  font-size: 13px;
}
.fontIntro{
  text-align: left
  color: #666666;
  font-size: 13px;
}
.fontName{
  font-size: 18px;
  white-space: nowrap;
  font-weight: 500;
  text-align: left;
  justify-content: left;
  font-family: PingFangSC-Medium, PingFang SC;
}
.fontWeight{
  
  font-weight: 500;
  text-align: left;
  justify-content: left;
  font-family: PingFangSC-Medium, PingFang SC;
}
.listItem .list-item .intro {
    background: #fff;
}
.listItem .list-item .tag-list {
    height: auto;
}
.listItem .list-item .headImg-border {
    width: 124px !important;
    height: 93px !important;
}
.headImg{
  width: 124px !important;
  height: 93px !important;
}

.noDataView{
  width: 100%;
  display: flex;
  justify-content: center;
}
.tagItem{
  border: 1px solid #E5E5E5;
  color: #808080 !important;
}
.headImg-part{
  width :40%
}
.content-part{
  width :60%;
  overflow: hidden
}
</style>



// WEBPACK FOOTER //
// src/components/ListItem.vue